/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router';
// material
import { Division, PrivateRoute } from '@insticator/insticator-ui'; // iui-material
// pages
// utils
// thunks
// styles
import injectSheet from 'react-jss';
import styles from './trendingnowv2_styles';
import TrendingNowV2ConfigPage from './trendingnowv2config/trendingnowv2config';
import TrendingNowV2AnalyticsPage from './trendingnowv2analytics/trendingnowv2analytics'


/* ========== ~~~~~~~~~~ TRENDING NOW V2 DIVISION ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => {
  const { accountProductsReceived, accountProducts, accountProductRequestStatus } = useSelector(state => state.account);
  const hasTrendingNowV2 = accountProducts.includes('TRENDING_NOW_V2')

  const permittedToConfig = hasTrendingNowV2 && accountProductsReceived
  const _getPermittedPath = useCallback(() => {
    if (accountProductRequestStatus === 'failed' || !accountProductsReceived) {
        return `/error/403`;
    }
    if (hasTrendingNowV2) {
        return '/dashboard/trendingnow/configuration'
    }
  }, [hasTrendingNowV2])

    return (
    <Division name={`trendingnowv2`} klass={props.classes.commenting}>
        <Switch>
            {/*Routes to subdivisions*/}
            <Route exact path='/dashboard/trendingnow' render={() => <Redirect to={'dashboard/trendingnow/configuration'} />} />
            <PrivateRoute permitted={permittedToConfig} redirectTo={_getPermittedPath()} path={'/dashboard/trendingnow/configuration'} component={TrendingNowV2ConfigPage} />
            <PrivateRoute permitted={permittedToConfig} redirectTo={_getPermittedPath()} path={'/dashboard/trendingnow/analytics'} component={TrendingNowV2AnalyticsPage} />
            <Redirect to='/error/404'/>
        </Switch>
    </Division>
    )
})